export default {"src":"/_next/static/media/icon_nav_dd_docs_square_on.8e48f5f3.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};